import { Loader, Spin, Table, InfiniteScrollLists, List, Card, NoResultFound, Wrapper, Pagination } from 'components'
import { detectMob } from 'shared/utils/detectDevice'
import style from 'components/style/table.module.css';

function TableList({ list, tableMode = null, tableModeOnly = null, listModeOnly = null, listMode = null, renderItem = null, message = null, loader, pageLoading, onChange, totalCount, pageSize = 10, pageNumber = 0, scrollableTarget = null, styleFromMsg=false , ...props }) {
    let locale = {
        emptyText: (
            <Card>
                <NoResultFound message={message ? message : 'No Data Found'} className={style.noResultFound} />
            </Card>
        )
    };
    return (<>
        {loader ?
            <Loader />
            :
            (tableModeOnly || !detectMob()) && !listModeOnly ? (
                <Spin spinning={pageLoading}>
                    {tableMode ?
                        <Table size="large" tabBarGutter="8" //  add size and tabbargutter @Date 20 Dec 2021 
                            onChange={(pagination) => onChange(pagination.current - 1, pageSize)}
                            columns={tableMode.columns}
                            dataSource={list}
                            title={false}
                            pagination={{ hideOnSinglePage: true, showQuickJumper: false, showSizeChanger: false, pageSize, total: totalCount }}
                            tableLayout="fixed"
                            scroll={{ x: '900' }}
                            fixed="top"
                            {...props}
                        />
                        :
                        <>

                            <List
                                grid={{ gutter: 16, column: 2, xs: 1, sm: 1, md: 1, lg: 1, xl: 1, ...listMode.grid }}
                                dataSource={list ? list : []}
                                locale={locale}
                                className="notify-list-item-m0 mt-2"
                                renderItem={(item, index) => (renderItem ? renderItem(item, index)
                                    :
                                    <List.Item style={{ width: '99%' }}>
                                        {/* <NotificationDetailItem {...item} checkAllChange={onCheckAllChange} deleteSelectedItem={deleteNotifyItems} /> */}
                                    </List.Item>
                                )}
                            />
                            <Wrapper className={"pagination-margin"}>
                                {list?.length > 0 && (totalCount / pageSize) > 1 &&
                                    <Pagination
                                        defaultCurrent={1}
                                        defaultPageSize={pageSize}
                                        onChange={() => onChange(pageNumber + 1, pageSize)}
                                        total={totalCount}
                                        showSizeChanger={false}
                                        showQuickJumper={false}
                                        hideOnSinglePage={true}
                                        //onShowSizeChange={handlePageNumChange}
                                        responsive={true}
                                    />
                                }
                            </Wrapper>
                        </>
                    }

                </Spin>


            ) : (
                <InfiniteScrollLists
                    loadMore={() => onChange(pageNumber + 1, pageSize)}
                    totalCount={totalCount}
                    list={list ? list : []}
                    listProps={listMode}
                    message={message}
                    styleFromMsg={styleFromMsg}
                    scrollableTarget={scrollableTarget ?? "primaryLayout"}
                    renderItem={(item, index) => (renderItem ? renderItem(item, index)
                        :
                        <List.Item >
                            {/* <NotificationDetailItem {...item} checkAllChange={onCheckAllChange} deleteSelectedItem={deleteNotifyItems} /> */}
                        </List.Item>
                    )}
                    {...props}
                />
            )
        }
    </>)
}

export default TableList
